import React, { useState } from 'react';
import { injectIntl } from 'react-intl';

import ActionButton, { SquaredButton } from './ActionButton';
import ActionLink from './ActionLink';
import Tooltip from './Tooltip';
import { isNotEmpty } from '../../lib/ep';

const CopyLink = (props) => {
	const copy_link = props?.copy_link ?? window.location.href;

	const [ just_copied, setJustCopied ] = useState(false);
	const [ error, setError ] = useState(false);

	const click = () => {
		if(props.disabled) return;

		try {
			navigator.clipboard.writeText(copy_link);
			setJustCopied(true);
			setTimeout(() => {
				setJustCopied(false);
				if(props.onClick != undefined) props.onClick();
			}, 1500);
		} catch(err) {
			setError(true);

			if(window.server_type == '2') {
				alert("Copy functionality is only available in HTTPS mode.\nReview the console to get the visible URL there.");
				console.warn(copy_link);
			} else {
				console.error("ERROR: The clipboard functionality is disabled in this browser", err);
			}

			setTimeout(() => {
				setError(false);
			}, 1500);
		}
	};

	let classes = (props._class != undefined) ? { ...props._class } : {};
	if(classes.other == undefined) classes.other = '';
	classes.other += ' copy_button';

	const input_label = (isNotEmpty(props, 'children')) ? props.children : "Copy";

	let label = input_label;
	let icon = props?.icon ?? 'knk-copy';
	if(just_copied) {
		label = (isNotEmpty(props, 'copied_label')) ? props.copied_label : "Copied!";
		icon = 'knk-on';
	} else if(error) {
		label = (isNotEmpty(props, 'error_label')) ? props.error_label : "Error";
		icon = 'knk-off';
	}

	const type = props?.type ?? 'link';

	if(type != 'link') {
		const hide_label = props?.hide_label ?? false;
		let tooltip = null;
		if(hide_label) {
			tooltip = <Tooltip with_icon={false} position='top'>{label}</Tooltip>;
			label = null;
		}
		
		const Component = (hide_label && type == 'button') ? SquaredButton : ActionButton;  

		return (
			<Component
				{...props}
				secondary={props?.secondary ?? true}
				_class={classes}
				icon={icon}
				onClick={click}
				tooltip={tooltip}
			>{label}</Component>
		)
	}

	return (
		<ActionLink
			{...props}
			_class={classes}
			onClick={() => click()}
		>{label}</ActionLink>
	);
}

export default injectIntl(CopyLink);